import type { EntityAdapter, EntityState } from '@ngrx/entity';
import type { Action } from '@ngrx/store';
import type { Uuid } from 'shared/common/types';
import { createEntityAdapter } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import * as ProgressesBackLinksActions from './progresses-back-links.actions';

export interface ProgressBackLink {
  progressId: Uuid;
  link: string[];
}

export interface ProgressesBackLinksState extends EntityState<ProgressBackLink> {
}

function selectId(p: ProgressBackLink): Uuid {
  return p.progressId;
}

const adapter: EntityAdapter<ProgressBackLink> = createEntityAdapter({
  selectId,
});

export const initialProgressesBackLinksState = adapter.getInitialState();

const reducer = createReducer(
  initialProgressesBackLinksState,
  on(ProgressesBackLinksActions.addBackLink, (state, data) => adapter.setOne(data, state)),
);

export function progressesBackLinksReducer(state: ProgressesBackLinksState | undefined, action: Action): ProgressesBackLinksState {
  return reducer(state, action);
}

export const {
  selectEntities,
} = adapter.getSelectors();
